import { Navigate, RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

const lazyAdminScreen = () =>
  import('./AdminScreen').then((m) => ({ Component: m.default }));

export const adminRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="mtm" />,
  },
  {
    path: 'momentm',
    lazy: lazyAdminScreen,
  },
  {
    path: 'mtm',
    lazy: lazyAdminScreen,
  },
  {
    path: 'internal',
    lazy: lazyAdminScreen,
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/admin" linkText="Go back to admin" />
    ),
  },
];
